<!-- eslint-disable vue/valid-template-root -->
<template lang="html">
    <Col :sm="24" :md="18" :lg="15" :xl="12">
        <Card class="card-box card-height d-flex align-item-center">
            <div class="text-center" v-if="isTripCountLoading">
            <Spinner/>
            </div>
            <div class="status-msg" v-else-if="!tripCount">
            <span>
                <svgicon :name="emptyDashboardIcon" width="150" height="115" :original="true" />
                <p class="mt-0 ml-30">No data available</p>
            </span>
            </div>
            <Row :gutter="40" class="list-bordered divider col-pt-15" v-else>
            <Col :span="header.colSpan"  v-for="header in tripCountHeaders" :key="header.id" :class="header.class">
              <Tooltip :open-delay="100" popper-class="max-width"  effect="dark" placement="top">
                <div slot="content">
                  <span v-html="trackingDashboard[header.column]"></span>
                </div>
                <ColCell
                :header="header"
                :value="tripCount[header.column]"
                @routeToTrack="$emit('routeToTrack', { routeCategory: 'status', header: $event })">
                </ColCell>
              </Tooltip>
            </Col>
            </Row>
        </Card>
    </Col>
</template>

<script>
import {
  filters,
  tripCountHeaders,
} from '@/constants/trackConstants';
import SecFilterMixin from '@common/mixins/SecFilterMixin';
import ColCell from '@/components/track/ColCell';

export default {
  components: {
    ColCell,
  },
  mixins: [SecFilterMixin],
  async created() {
    this.apiTrigger.$on('loadMore', (args) => {
      this.search();
    });
  },
  data() {
    return {
      etaCompliance: null,
      filters,
      isDarkTheme: true,
      fill1: { color: '#7467F0' },
      fill2: { color: '#4CD7A9' },
      startAngle: -Math.PI / 2,
      isTripCountLoading: true,
      tripCount: null,
      tripCountHeaders,
    };
  },
  props: ['queryParams', 'apiTrigger', 'emptyDashboardIcon', 'trackingDashboard'],
  methods: {
    async search() {
      const resultObj = 'tripCount';
      const loadingObj = 'isTripCountLoading';
      const section = 'tripCount';
      const params = this.queryParams;
      this[loadingObj] = true;
      const result = await this.$store.dispatch('track/getDashboardDetails', { section, params });
      if (result && !result.error) {
        this[resultObj] = result;
      } else {
        this[resultObj] = null;
      }
      this[loadingObj] = false;
    },
    routeToTrack(category, header) {
      if (header.routerActive) {
        const dateRange = this.findByCategory(this.filters.DATE);
        const transporter = this.findByCategory(this.filters.TRANSPORTER);
        let query = {
          fromDashboard: true,
          start: dateRange.startDate && this.$moment(dateRange.startDate).startOf('day').toISOString(),
          end: dateRange.startDate && this.$moment(dateRange.endDate).startOf('day').toISOString(),
        };
        if (transporter && transporter.id && transporter.id !== -1) {
          query = Object.assign(query, { trans: transporter.name, transporterId: transporter.id });
        }
        if (category) {
          const obj = {};
          obj[category] = header.routerValue;
          query = Object.assign(query, obj);
        }
        if (header.routerParent) {
          query = Object.assign(query, header.routerParent);
        }
        this.$router.push({ name: 'Trips', query });
      }
    },
  },
};
</script>

